import React, { useState } from "react";
import LottoRows from "./rows/LottoRows";
import NumbersUtil from "../util/NumbersUtil";
import localDao from '../data/localDao';
import { useTranslation } from 'react-i18next';
import GameType from "../data/GameType";
import NumberCountSelector from "./NumberCountSelector";
import StakeSelector from "./StakeSelector";
import { useNavigate, useLoaderData, useParams, useSearchParams } from "react-router-dom";
import GameHeader from "./GameHeader";
import GameStartButtons from "./GameStartButtons";
import AddToCart from "./AddToCart";
import DrawCountSelector from "./DrawCountSelector";
import trashIcon from '../icons/trash.svg';
import pencilIcon from '../icons/pencil.svg';

const getRandomRow = (gameType, kenoCount) => {
    if (gameType === GameType.KENO) {
        return NumbersUtil.randomKeno(kenoCount);
    } else {
        return NumbersUtil.randomRow(gameType);
    }
};
const Game = (props) => {
    const game = useLoaderData();
    const [rows, setRows] = useState(game?.rows || props.game?.rows || []);
    const [isExpanded, setIsExpanded] = useState(typeof props.isExpanded === 'undefined' ? true : props.isExpanded);
    const [kenoStake, setKenoStake] = useState(game?.stake || props.game?.stake || 200);
    const [kenoCount, setKenoCount] = useState(10);
    const params = useParams();
    const [searchParams] = useSearchParams();
    const gameType = params.game ? GameType.getGameType(params.game) : props.gameType;
    const navigate = useNavigate();
    const [drawCount, setDrawCount] = useState(game?.drawCount || props.game?.drawCount || 1);
    const { t } = useTranslation();
    //Fills with initial row when game opened from start buttons
    if (rows.length < 1 && searchParams.size > 0 && !searchParams.get("utm_source")) {
        let row;
        if (searchParams.get("initialData") === "random") {
            row = getRandomRow(gameType, kenoCount);
        } else {
            row = GameType.emptyRow();
        }
        row.editorOpen = true;
        setRows([row]);
    }
    const addNumber = (numbers, number, nrType) => {
        var max = gameType.name === GameType.KENO.name ? kenoCount : gameType[nrType + "Max"];
        if (numbers.length !== max) {
            numbers.push(number);
        }
    };
    const toggleNumber = (row, number, nrType) => {
        var numbers = row[nrType];
        if (numbers.includes(number)) {
            numbers.splice(numbers.indexOf(number), 1);
        } else {
            addNumber(numbers, number, nrType);
        }
        NumbersUtil.sort(numbers);
        return row;
    };
    const onClickNumber = (rowNr, number, nrType) => {
        setRows((prev) => {
            var result = JSON.parse(JSON.stringify(prev));
            result[rowNr] = toggleNumber(result[rowNr], number, nrType);
            return result;
        });
    };
    const addRow = () => {
        setRows((prev) => {
            var result = JSON.parse(JSON.stringify(prev));
            result.push({ "main": [], "extra": [], editorOpen: true });
            return result;
        });
    };
    const saveGame = (newRows) => {
        var stake = gameType === GameType.KENO ? kenoStake : gameType.stake;
        localDao.saveGameToCart(gameType, {drawCount: drawCount, stake: stake, rows: newRows});
    };
    const deleteGame = () => {
        saveGame([]);
        setRows([]);
        props.onDeleteGame && props.onDeleteGame();
        navigate(process.env.PUBLIC_URL + "/");
    };
    const addToCart = () => {
        var newRows = [...rows];
        newRows.map((row) => {
            if (gameType === GameType.KENO) {
                row.stake = kenoStake;
            }
            row.editorOpen = false;
            return row;
        });
        saveGame(newRows);
        navigate(process.env.PUBLIC_URL + "/");
    };
    const openRow = (rowIndex) => {
        var newRows = [...rows];
        rows[rowIndex].editorOpen = true;
        saveGame(newRows);
        navigate(process.env.PUBLIC_URL + "/game/" + gameType.name);
    };
    const toggleEditor = (rowIndex, isExpanded) => {
        if (!props.isOpen) {
            openRow(rowIndex);
        } else {
            setRows((prev) => {
                var result = JSON.parse(JSON.stringify(prev));
                result[rowIndex].editorOpen = isExpanded;
                return result;
            });
        }
    };
    
    const randomizeRow = (rowIndex) => {
        var row = getRandomRow(gameType, kenoCount);
        setRows((prev) => {
            var result = JSON.parse(JSON.stringify(prev));
            row.editorOpen = prev[rowIndex].editorOpen;
            result[rowIndex] = row;
            return result;
        });
    };
    const toggleOpen = () => {
        navigate(process.env.PUBLIC_URL + "/game/" + gameType.name);
    };
    const deleteRow = (i) => {
        setRows((prev) => {
            var result = JSON.parse(JSON.stringify(prev));
            result.splice(i, 1);
            saveGame(result);
            return result;
        });
    };
    const createRows = () => {
        var lottoRows = (<LottoRows
            isExpanded={isExpanded}
            compactOnly={props.compactOnly || false}
            gameType={gameType}
            rows={rows}
            toggleEditor={toggleEditor}
            onClickNumber={onClickNumber}
            onDelete={deleteRow}
            onRandom={randomizeRow}
            kenoCount={kenoCount}
        ></LottoRows>);
        if (props.compactOnly && !props.isFinal) {
            return (
                <div className="flex">
                    <div>
                        {lottoRows}
                    </div>
                    <div className="flexEnd inlineFlex lightGrey2Bg">
                        <div className='inlineFlex flexColumn padding1'>
                            <img alt='' className='icon editGame' src={trashIcon} onClick={deleteGame}></img>
                            <img alt='' className='icon editGame marginTop2' src={pencilIcon} onClick={() => toggleOpen()}></img>
                        </div>
                    </div>
                </div>
            );
        } else {
            return lottoRows;
        }
    };
    const createStartButtons = () => {
        return (
            <GameStartButtons gameType={props.gameType}></GameStartButtons>
        );
    };
    const updateKenoCount = (count) => {
        setKenoCount(count);
        setRows((prev) => {
            var result = [...prev];
            result.forEach((row) => {
                row.main = row.main.slice(0, count);
            });
            return result;
        });
    };
    const createKenoHeader = () => {
        return (
            <div className="kenoSelectors marginBottom1">
                <NumberCountSelector onSelect={(count) => { updateKenoCount(count) }} count={kenoCount} max={10}></NumberCountSelector>
                <StakeSelector onSelect={(stake) => { setKenoStake(stake) }} stake={kenoStake} stakes={[100, 200, 500, 1000, 1500]}></StakeSelector>
            </div>
        );
    };
    const calculatePrice = () => {
        var stake = gameType === GameType.KENO ? kenoStake : gameType.stake;
        stake = stake / 100;
        var price = stake * rows.length * drawCount;
        return NumbersUtil.padPrice(price);
    };

    return (
        <div className={(rows.length > 0 ? '' : 'empty ') + (props.isOpen ? 'open' : 'closed') + ' game'}>
            <GameHeader
                isOpen={props.isOpen}
                rows={rows}
                isExpanded={isExpanded}
                onToggleExpanded={setIsExpanded}
                gameType={gameType}
                calculatePrice={calculatePrice}
                onEdit={() => toggleOpen()}
                deleteGame={deleteGame}
            ></GameHeader>
            {(gameType === GameType.KENO && props.isOpen) && createKenoHeader()}
           
            <div className="whiteBgRounded ">
            
            {rows.length > 0 && isExpanded && createRows()}
                {props.isOpen && 
                    <button disabled={rows.length >= GameType.labels.length - 1} className="button bold marginBottom1 marginTop1 marginLeft1 roundSquare button--success" onClick={addRow}>
                        {t('button.addRow')}
                    </button>}
            </div>

            <div className="stickyBar">
                {props.isOpen && <DrawCountSelector drawCount={drawCount} gameType={gameType} setDrawCount={setDrawCount}></DrawCountSelector>} 
                {props.isOpen && <AddToCart rows={rows} gameType={gameType} calculatePrice={calculatePrice} addToCart={addToCart}></AddToCart>}
                {(!props.isOpen && !props.isFinal && rows.length > 0) && <div className="afterBorder05 margin1"></div>}
            </div>
        </div>
    );
};

export default Game;